module.exports = __webpack_public_path__ + "img/about4.a09019e6.png";